<script>
    import {PATH_PREFIX} from '../../../apiUrls.js';

    import {onMount} from 'svelte';
    import MultiSelection from '../MultiSelectItem.svelte';
    import Select from 'svelte-select';
    import {submit} from '../../Form/utils.js';
    import {get} from '../../../utils.js';

    export let elementVersionId = null;
    export let readOnly = false;
    export let isDisabled = false;
    $: competenciesUrl = `${PATH_PREFIX}/sw/api/elements_database/element_version/competencies/${elementVersionId}/`;
    $: setCompetenciesUrl = `${PATH_PREFIX}/sw/api/elements_database/element_version/competencies/set/${elementVersionId}/`;
    $: availableCompetenciesUrl = `${PATH_PREFIX}/sw/api/elements_database/element_version/competencies/available/${elementVersionId}/`;
    $: {
        if (elementVersionId)
            getCompetencies();
    }

    let competencies = [];
    let availableCompetencies = [];
    let loadingCompetencies = false;

    onMount(async () => {
        if (elementVersionId)
            await getCompetencies();
    });

    async function getCompetencies() {
        try {
            const url = `${competenciesUrl}`;
            const resp = await get(url);
            const c = await resp.json();
            competencies = c.results;
        }
        catch (err) {
            console.log(err);
        }
    }

    async function getAvailableCompetencies(filterText) {
        loadingCompetencies = true;
        try {
            const url = `${availableCompetenciesUrl}?name=${filterText}`;
            const resp = await get(url);
            const results = await resp.json();
            availableCompetencies = results.map((c) => {return {
                id: null,
                competency: c.id,
                name: c.name,
                competency_name: c.name
            }});
        }
        catch (err) {
            console.log(err);
        }

        loadingCompetencies = false;
    }

    function loadOptions(filterText) {
        return new Promise(async (resolve, reject) => {
            await getAvailableCompetencies(filterText);
        })
    }

    const optionIdentifier = 'competency_name';
    const getOptionLabel = (option) => option.competency_name;
    const getSelectionLabel = (option) => option.competency_name;

    async function saveTags() {
        loadingCompetencies = true;
        const url = `${setCompetenciesUrl}`;
        const method = 'PATCH';
        const jsonData = competencies;

        try {
            await submit(url, method, jsonData);
        } catch (err) {
            console.error(err);
        } finally {
            loadingCompetencies = false;
        }
    }

</script>

<style>

</style>

{#if readOnly}
    <div class="d-flex">
        {#each competencies as competency}
            <div class="badge badge-pill badge-secondary mr-1 mb-1">{competency.competency_name}</div>
        {/each}
    </div>
{:else}
    <Select
            {optionIdentifier}
            {getSelectionLabel}
            {getOptionLabel}
            {loadOptions}
            {MultiSelection}
            bind:items={availableCompetencies}
            bind:selectedValue={competencies}
            bind:isWaiting={loadingCompetencies}
            {isDisabled}
            isMulti={true}
            isCreatable={false}
            hideEmptyState={true}
            on:select={saveTags}
            on:clear={saveTags}>
    </Select>
{/if}
